"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSearchRegExp = exports.getNoMatchesOption = exports.getEmptyGroup = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var emptyGroup;

var getEmptyGroup = function getEmptyGroup() {
  emptyGroup = emptyGroup || {
    disabled: true,
    text: _I18n.default.text('salesUI.UITypeahead.noOptions'),
    value: '__EMPTY_GROUP__'
  };
  return emptyGroup;
};

exports.getEmptyGroup = getEmptyGroup;
var noMatchesOption;

var getNoMatchesOption = function getNoMatchesOption() {
  noMatchesOption = noMatchesOption || {
    disabled: true,
    groupIdx: -1,
    text: _I18n.default.text('salesUI.UITypeahead.noMatchesFound'),
    value: '__EMPTY_OPTION__'
  };
  return noMatchesOption;
};

exports.getNoMatchesOption = getNoMatchesOption;

var getSearchRegExp = function getSearchRegExp(str) {
  return new RegExp(str.trim().replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
};

exports.getSearchRegExp = getSearchRegExp;